// extracted by mini-css-extract-plugin
module.exports = {"layout":"app_layout__27ojb"};